import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { LoginComponent } from './auth/login/login.component';
import { LayoutComponent } from './dashbord/layout/layout.component';


const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren :() => import('./dashbord/dashbord.module').then(m=>m.DashbordModule)
   
  },
  {path:'auth' , loadChildren :() => import('./auth/auth.module').then(m=>m.AuthModule)},
   {path:'dashbord' , canActivate: [AuthGuard], 
    loadChildren :() => import('./dashbord/dashbord.module').then(m=>m.DashbordModule)}
,
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
   imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
